import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { AnimatePresence, motion, useReducedMotion, type Variants } from 'framer-motion';
type WaveWord = {
  text: string;
  muted?: boolean;
};
type WaveTextProps = {
  words: WaveWord[];
};
const line: Variants = {
  visible: {
    transition: {
      staggerChildren: 0.02
    }
  },
  exit: {
    transition: {
      staggerChildren: 0.004
    }
  }
};
const letter: Variants = {
  hidden: {
    opacity: 0,
    y: '0.35em',
    filter: 'blur(10px)'
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  },
  exit: {
    opacity: 0,
    y: '-0.15em',
    filter: 'blur(6px)',
    transition: {
      duration: 0.18,
      ease: 'easeOut'
    }
  }
};
const Word = t0 => {
  const $ = _c(8);
  const {
    word,
    animated
  } = t0;
  const t1 = word.muted && "text-tertiary";
  let t2;
  if ($[0] !== t1) {
    t2 = cx("inline-block whitespace-nowrap", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== animated || $[3] !== word.text) {
    t3 = animated ? Array.from(word.text).map(_temp) : word.text;
    $[2] = animated;
    $[3] = word.text;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <span className={t2}>{t3}</span>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
const WaveText = t0 => {
  const $ = _c(12);
  const {
    words
  } = t0;
  const reduceMotion = useReducedMotion() ?? false;
  let t1;
  if ($[0] !== reduceMotion || $[1] !== words) {
    let t2;
    if ($[3] !== reduceMotion) {
      t2 = (word, index) => <span key={index}>{index > 0 && " "}<Word word={word} animated={!reduceMotion} /></span>;
      $[3] = reduceMotion;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = words.map(t2);
    $[0] = reduceMotion;
    $[1] = words;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const content = t1;
  if (reduceMotion) {
    let t2;
    if ($[5] !== content) {
      t2 = <span>{content}</span>;
      $[5] = content;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  let t2;
  if ($[7] !== words) {
    t2 = words.map(_temp2).join(" ");
    $[7] = words;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== content || $[10] !== t2) {
    t3 = <AnimatePresence mode="wait"><motion.span key={t2} variants={line} initial="hidden" animate="visible" exit="exit" className="block">{content}</motion.span></AnimatePresence>;
    $[9] = content;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export type { WaveWord };
export default WaveText;
function _temp(char, index) {
  return <motion.span key={index} variants={letter} className="inline-block">{char}</motion.span>;
}
function _temp2(word_0) {
  return word_0.text;
}